const Dashboard = require('./dashboard');

module.exports = { Dashboard };
